import { SAVE_EVENT_DATA, SAVE_GROUPS_DATA, SET_EVENT_DATA } from "./types";
export function saveEventData(data) {
    return {
        type: SAVE_EVENT_DATA,
        payload: data,
    };
}
export function setEventData(data) {
    return {
        type: SET_EVENT_DATA,
        payload: data,
    };
}
export function saveGroupsData(data) {
    return {
        type: SAVE_GROUPS_DATA,
        payload: data,
    };
}
